import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MuiToolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";

const Toolbar = ({classes, children, disableGutters, title, subtitle, items}) => (
    <MuiToolbar disableGutters={disableGutters}>
        <Typography
            variant="h2"
            className={classes.tabBarTitle}
        >
            {title}
        </Typography>

        <Typography variant="subtitle2">
            {subtitle}
        </Typography>

        {/* Insert children here */}
        {children}

        {/* Build buttoms from list */}
        {items.map(item => (
            <React.Fragment>
                {!item.hidden &&
                <Button
                    key={item.href}
                    component={item.component || "a"}
                    variant={item.variant || 'contained'}
                    color={item.color || 'primary'}
                    href={item.href}
                    onClick={item.onClick}
                    className={classes.tabBarButton}
                >
                    {item.icon &&
                    <Icon className={classes.tabBarButtonIcon}>
                        {item.icon}
                    </Icon>
                    }
                    {item.fontawesome}
                    {item.text}
                </Button>
                }
            </React.Fragment>
        ))}
    </MuiToolbar>
);

Toolbar.propTypes = {
    disableGutters: PropTypes.bool,
    title: PropTypes.any.isRequired,
    subtitle: PropTypes.any,
    items: PropTypes.array,
};

Toolbar.defaultProps = {
    items: [],
};

const styles = theme => ({
    tabBar: {
        marginBottom: theme.spacing.unit * 3,
    },
    tabBarTitle: {
        flexGrow: 1,
    },
    tabBarButton: {
        marginLeft: theme.spacing.unit * 2,
    },
    tabBarButtonIcon: {
        marginRight: theme.spacing.unit,
    },
});

export default withStyles(styles)(Toolbar);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Toolbar/Toolbar.jsx